import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../config/firebaseConfig";
import Button from "../../../components/common/button";
import { useNavigate } from "react-router-dom";

export const Oppsummering: React.FC<{ bankData: any; setActiveTab: any }> = ({
  bankData,
  setActiveTab,
}) => {
  const [finalData, setFinalData] = useState<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const husmodellDocRef = doc(
          db,
          "house_model",
          String(bankData?.plotHusmodell?.house?.housemodell)
        );
        const husmodellDocSnap = await getDoc(husmodellDocRef);

        if (husmodellDocSnap.exists()) {
          setFinalData(husmodellDocSnap.data());
        } else {
          console.error("No document found for husmodell ID.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    if (bankData?.plotHusmodell?.house?.housemodell) {
      fetchData();
    }
  }, [bankData]);
  const plotData = bankData?.plotHusmodell?.plot;
  const houseData = bankData?.plotHusmodell?.house;

  function norwegianToNumber(str: any) {
    if (typeof str !== "string") return 0;
    return Number(str.replace(/\s/g, ""));
  }

  const sum =
    norwegianToNumber(plotData?.tomtekostnader) +
    norwegianToNumber(houseData?.byggekostnader);

  function numberToNorwegian(num: any) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  return (
    <>
      <div className="mb-20">
        <div className="rounded-lg bg-lightGreen mb-6 w-full">
          <div className="p-3 md:p-4">
            <h3 className="text-base lg:text-lg font-semibold text-black3 mb-2">
              Oppsummering
            </h3>
            <p className="text-sm text-gray4">
              Her fyller du inn informasjon om prosjektet.
            </p>
          </div>
          <div className="p-1 pt-0">
            <div className="bg-white p-4 rounded-lg border border-gray3 shadow-shadow4">
              <div className="text-sm lg:text-base text-black3 font-medium">
                Informasjon om kunden
              </div>
              <div className="py-3 md:py-5 grid grid-cols-1 desktop:grid-cols-2 gap-4 md:gap-6">
                {bankData &&
                  bankData?.Kunden?.Kundeinformasjon.length &&
                  bankData?.Kunden?.Kundeinformasjon.map(
                    (item: any, index: number) => {
                      return (
                        <div className="flex flex-col gap-2" key={index}>
                          <div className="flex gap-2 md:gap-3 items-center">
                            <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                              Type
                            </div>
                            <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                              {item?.Kundetype}
                            </div>
                          </div>
                          <div className="flex gap-3 items-center">
                            <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                              Navn:
                            </div>
                            <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all  text-darkBlack text-xs md:text-sm">
                              {item?.f_name} {item?.l_name}
                            </div>
                          </div>
                          <div className="flex gap-3 items-center">
                            <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                              Adresse:
                            </div>
                            <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all  text-darkBlack text-xs md:text-sm">
                              {item?.Adresse}
                            </div>
                          </div>
                          <div className="flex gap-3 items-center">
                            <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                              Mobil:
                            </div>
                            <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all  text-darkBlack text-xs md:text-sm">
                              {item?.mobileNummer}
                            </div>
                          </div>
                          <div className="flex gap-3 items-center">
                            <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                              E-post:
                            </div>
                            <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all  text-darkBlack text-xs md:text-sm">
                              {item?.EPost}
                            </div>
                          </div>
                          <div className="flex gap-3 items-center">
                            <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                              Fødselsdato:
                            </div>
                            <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all  text-darkBlack text-xs md:text-sm">
                              {item?.dato}
                            </div>
                          </div>
                        </div>
                      );
                    }
                  )}
              </div>
              <div className="border-t border-gray4 mb-5"></div>
              <div className="text-sm lg:text-base text-black3 font-medium">
                Informasjon om tomten
              </div>
              <div className="py-3 md:py-5">
                <div className="flex flex-col gap-2">
                  <div className="flex gap-3 items-center">
                    <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                      Adresse:
                    </div>
                    <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                      {plotData?.address}
                    </div>
                  </div>
                  <div className="flex gap-3 items-center">
                    <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                      Kunden eier tomten allerede:
                    </div>
                    <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                      {plotData?.alreadyHavePlot
                        ? plotData?.alreadyHavePlot
                        : "Nei"}
                    </div>
                  </div>
                  <div className="flex gap-3 items-center">
                    <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                      Totale tomtekostnader:
                    </div>
                    <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                      kr {plotData?.tomtekostnader}
                    </div>
                  </div>
                  <div className="flex gap-3 items-center">
                    <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                      Kommentar:
                    </div>
                    <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                      {plotData?.Kommentar}
                    </div>
                  </div>
                </div>
              </div>
              <div className="border-t border-gray4 mb-3 md:mb-5"></div>
              <div className="text-sm lg:text-base text-black3 font-medium">
                Informasjon om husmodellen
              </div>
              <div className="py-3 md:py-5">
                <div className="flex flex-col gap-2">
                  <div className="flex gap-3 items-center">
                    <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                      Husmodell
                    </div>
                    <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                      {finalData?.Husdetaljer?.husmodell_name}
                    </div>
                  </div>
                  <div className="flex gap-3 items-center">
                    <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                      Totale byggekostnader:
                    </div>
                    <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                      kr {houseData?.byggekostnader}
                    </div>
                  </div>
                  <div className="flex gap-3 items-center mb-3">
                    <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                      Kommentar:
                    </div>
                    <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                      {houseData?.Kommentar}
                    </div>
                  </div>
                </div>
              </div>
              <div className="border-t border-gray4 mb-3 md:mb-5"></div>
              <div className="text-sm lg:text-base text-black3 font-medium">
                Informasjon om økonomisk plan
              </div>
              <div className="py-3 md:py-5">
                <div className="flex flex-col gap-2">
                  <div className="flex gap-3 items-center">
                    <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                      Lastet opp
                    </div>
                    <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                      {bankData?.ProjectAccount?.Økonomisk ===
                      "Last opp en økonomisk plan"
                        ? "Ja"
                        : "Nei"}
                    </div>
                  </div>
                  <div className="flex gap-3 items-center">
                    <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                      Operettet
                    </div>
                    <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                      {bankData?.ProjectAccount?.Økonomisk ===
                      "Opprett en økonomisk plan"
                        ? "Ja"
                        : "Nei"}
                    </div>
                  </div>
                  <div className="flex gap-3 items-center mb-3">
                    <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                      Ettersendes
                    </div>
                    <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                      {bankData?.ProjectAccount?.Økonomisk ===
                      "Ettersend en økonomisk plan"
                        ? "Ja"
                        : "Nei"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-skyBlue rounded-lg py-3 px-3 md:px-4 flex flex-col gap-2 sm:gap-3">
                <div className="flex gap-2 sm:gap-3 items-center">
                  <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                    Sum tomtekostnader
                  </div>
                  <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm font-medium">
                    kr {plotData?.tomtekostnader}
                  </div>
                </div>
                <div className="flex gap-2 sm:gap-3 items-center">
                  <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                    Sum byggekostnader
                  </div>
                  <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm font-medium">
                    kr {houseData?.byggekostnader}{" "}
                    <span className="text-gray4 text-xs md:text-sm font-normal">
                      (prosjektregnskapet oversendes banken)
                    </span>
                  </div>
                </div>
                <div className="border-t border-grey2 w-full"></div>
                <div className="flex gap-2 sm:gap-3 items-center">
                  <div className="w-[130px] sm:w-[200px] md:w-[300px] font-medium text-darkBlack text-xs md:text-sm">
                    Totale kostnader
                  </div>
                  <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm font-medium">
                    kr {numberToNorwegian(sum)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white pb-2 bottom-0 fixed w-[calc(100%-16px)] left-2">
        <div className="flex justify-end w-full gap-4 items-center  bg-white z-50 border border-gray3 p-3 md:p-4">
          <Button
            text="Avbryt"
            className="border-2 border-primary text-primary text-base rounded-[34px] h-10 md:h-12 font-semibold relative px-6 md:px-8 py-[10px] flex items-center gap-2"
            onClick={() => navigate("/agent-leads")}
          />
          <div id="submit">
            <Button
              text="Neste"
              className="border border-primary bg-primary text-white text-base rounded-[34px] h-10 md:h-12 font-semibold relative px-6 md:px-8 py-[10px] flex items-center gap-2"
              onClick={() => setActiveTab(1)}
            />
          </div>
        </div>
      </div>
    </>
  );
};
